var link_viewer_default = {
  "fontElementMap": "_3-AOd",
  "link": "F7zhU",
  "linkInEditor": "bf7-C",
  "linkInViewer": "_15OuR",
  "toolbarUrlContainer": "GEh9a",
  "toolbarUrl": "_04kZw",
  "toolbarUrlAnchor": "kmyGv"
};
export {
  link_viewer_default as default
};
//# sourceMappingURL=link-viewer-scss.js.map
